import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ManagedSettingsStoreActions } from '../../../../shared/managed-settings-store/index';
import { HostName, ManagedSettingsHostNameComponent } from './host-name.component';

@Component({
  selector: 'ml-host-name',
  templateUrl: './host-name.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ManagedSettingsHostNameComponent],
})
export class ManagedSettingsHostNameContainerComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);

  private udid: string;

  // TODO: Refactor to getting the UDID with NGRX later.
  private readonly subscriptions: Subscription[] = [];

  hostName(hostName: HostName) {
    this.store.dispatch(
      ManagedSettingsStoreActions.ManagedSettingsCommandActions.hostName({
        udid: this.udid,
        hostName: hostName.hostName,
      })
    );
  }

  ngOnInit() {
    if (!this.route.parent) {
      return;
    }

    this.subscriptions.push(
      this.route.parent.params
        .pipe(
          map((p: Params) => p.udid),
          filter((udid) => udid),
          distinctUntilChanged()
        )
        .subscribe((id) => (this.udid = id))
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
